<template>
    <h6 class="title">
        {{ text }}
    </h6>
</template>

<script>
export default {
    name: 'Titles',
    props: {
        text: {
            type: String,
            required: true,
        }
    }
};
</script>

<style scoped></style>